import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Simple in-module cache so multiple hook instances share one fetch.
let cache = null;
let promise = null;
let poller = null;
const listeners = new Set();

function notify() {
  listeners.forEach((cb) => cb(cache));
}

async function fetchCapacity() {
  if (promise) return promise;
  promise = axios
    .get(`${API}/capacity`, { params: { _: Date.now() } })
    .then((r) => {
      cache = r.data;
      notify();
      return cache;
    })
    .catch(() => {
      // Sensible fallback if API is unreachable
      cache = { total: 350, remaining: 97, sold: 253, tier: "few", vip_total: 50, vip_remaining: 19 };
      notify();
      return cache;
    })
    .finally(() => {
      promise = null;
    });
  return promise;
}

// One shared poller for the whole app: refetch every 30s and on tab focus,
// so admin changes show up on the site without a manual refresh.
function ensurePolling() {
  if (poller) return;
  poller = setInterval(fetchCapacity, 30000);
  window.addEventListener("focus", fetchCapacity);
}

export function labelFor(tier, remaining) {
  if (tier === "sold_out") return "РАЗПРОДАДЕНО";
  if (tier === "last") return `ПОСЛЕДНИ ${remaining} БИЛЕТА`;
  if (tier === "few") return `Остават само ${remaining} билета`;
  return "Местата се запълват";
}

export default function useCapacity() {
  const [state, setState] = useState(cache);

  useEffect(() => {
    fetchCapacity(); // always revalidate on mount, even if cached
    ensurePolling();
    const cb = (val) => setState(val);
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);

  const data = state || cache || { total: 350, remaining: 97, sold: 253, tier: "few", vip_total: 50, vip_remaining: 19 };
  const percent = data.total > 0 ? Math.min(100, Math.round((data.sold / data.total) * 100)) : 0;
  return { ...data, percent, label: labelFor(data.tier, data.remaining) };
}
